<app-spinner></app-spinner>
<div class="main-container">
  <div class="fadeInLayer">
    <div *ngIf="url">
      <iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe"></iframe>
    </div>
  </div>
</div>
